howspace.components.videoPlayer = (() => {
    'use strict';

    const defaultOptions = {
        controls: true,
        autoplay: true,
        responsive: true,
        preload: 'none',
        playbackRates: [
            0.5,
            1,
            1.25,
            1.5,
            1.75,
            2
        ]
    };

    // TODO: Move this to some generic location
    const SUBTITLE_ADDED = 'subtitle-added';

    async function loadVideoJS() {
        await lib('video.js', 'video.min.js');
        await lib('videojs-vjsdownload', 'videojs-vjsdownload.js');
    }

    $(document).on(SUBTITLE_ADDED, async (event) => {
        const { uploadedFileId, subtitle, subtitleType } = event.originalEvent.detail;
        const matchesSubtitle = track => track.kind === subtitle.kind && track.label === subtitle.label;
        const videoPlayer = $(`.howspace-video-player[data-uploadedfile-id="${uploadedFileId}"]`);
        if (videoPlayer.length === 0) {
            return;
        } else if (subtitleType === 'auto' && !videoPlayer.data('auto-subtitle-enabled')) {
            return;

        }
        const videoJsElem = videoPlayer.find('.video-js');
        if (videoJsElem.length > 0) {
            // Player is active, subtitle is added via vjs API.
            await loadVideoJS();
            const vjs = videojs(videoJsElem[0]);

            // Remove existing subtitles with the same name and check if they were on display.
            let textTracks = vjs.textTracks();
            const tracks = Array.from(textTracks).filter(matchesSubtitle);
            let show = false;
            for (const track of tracks) {
                if (track.mode === 'showing') {
                    show = true;
                }
                vjs.removeRemoteTextTrack(track);
            }

            vjs.addRemoteTextTrack(subtitle, false);

            // Put the new subtitles back on display if they were replaced.
            if (show) {
                // The element returned by addRemoteTextTrack cannot be used to do this.
                textTracks = vjs.textTracks();
                for (let i = 0; i < textTracks.length; i++) {
                    const track = textTracks[i];
                    if (matchesSubtitle(track)) {
                        track.mode = 'showing';
                    }
                }
            }
        } else {
            // Player isn't active, subtitle is only added to our data attribute.
            let subtitles = videoPlayer.data('subtitles') || [];
            subtitles = subtitles.filter(track => track.kind !== subtitle.kind || track.label !== subtitle.label);
            subtitles.push(subtitle);
            videoPlayer.dataAndAttr('subtitles', subtitles);
        }
    });

    /**
     * @param {*} videoPlayer
     * @param {*} options
     * @returns
     */
    const initVideoJs = async (videoPlayer, options = {}) => {
        if (videoPlayer.is('.video-js-initialized, [data-is-stored="false"], [data-mp4-url=""]')) {
            // VideoJS is already initialized, video file is not stored or URL is empty.
            return;
        }

        if (!videoPlayer.is('.howspace-video-player-initialized')) {
            // Video player is no longer initialized.
            return true;
        }

        videoPlayer.addClass('video-js-initialized');

        let subtitleTrackHtml = '';
        /**
         * NOTE: Cannot utilize the HTML5 default attribute due vjs selecting
         * another subtitle with the same language.
         */
        let defaultSubtitle = null;
        const subtitles = videoPlayer.data('subtitles');
        if (subtitles) {
            for (const subtitle of subtitles) {
                if (subtitle.default) {
                    defaultSubtitle = subtitle;
                }
                subtitleTrackHtml += `<track kind="subtitles" srclang="${subtitle.srclang}" src="${subtitle.src}" label="${subtitle.label}">`;
            }
        }

        videoPlayer.append(
            `<video class="video-js vjs-default-skin howspace-video-responsive-item">
                <source type="video/mp4" src="${videoPlayer.data('mp4-url')}">
                ${subtitleTrackHtml}
            </video>`
        );

        if (!options) {
            options = {};
        }

        let playerOptions = $.extend({}, defaultOptions, options);

        if (videoPlayer.data('poster-file-url')) {
            playerOptions.poster = videoPlayer.data('poster-file-url');
        }

        playerOptions.html5 = {
            // Since we auto-trigger subtitle translations in the subtitle controller,
            // we don't want the clients to preload subtitles.
            preloadTextTracks: false,
        };

        playerOptions.controlBar = {
            pictureInPictureToggle: false
        }

        const videoJsElem = videoPlayer.find('.video-js')[0];

        const allowDownloadVideo = videoPlayer.data('allow-download-video');

        if (allowDownloadVideo) {
            playerOptions.plugins = {
                vjsdownload: {
                    textControl: howspace.translate('videoplayer_download_video_button'),
                    name: 'downloadButton',
                    downloadURL: videoPlayer.data('download-file-url'),
                }
            };
        }

        if (allowDownloadVideo === false) {
            $(videoJsElem).on('contextmenu', (event) => {
                event.preventDefault();
            });
        }

        await loadVideoJS();
        const vjs = videojs(videoJsElem, playerOptions, () => {
            const videoJsPlayer = videojs.getPlayer(videoJsElem);
            const eventDetail = {
                player: videoJsPlayer
            }

            videoJsPlayer.reloadSourceOnError();

            if (videoPlayer.data('shareable-modal')) {
                const shareableModalUrl = videoPlayer.data('shareable-modal');
                const shareableModalInit = videoPlayer.data('shareable-modal-init');
                const fullscreen = videoJsPlayer.controlBar.getChild("FullscreenToggle");
                const index = videoJsPlayer.controlBar.children().indexOf(fullscreen);

                const shareButton = videoJsPlayer.controlBar.addChild("button", {
                    className: "vjs-share-button",
                    controlText: howspace.translate('common_share_a_moment')
                }, index + 1);

                const shareButtonPlaceholder = shareButton.el().getElementsByClassName("vjs-icon-placeholder")[0];
                if (shareButtonPlaceholder) {
                    shareButtonPlaceholder.innerHTML = `<i class="fa-light fa-share"></i>`;
                }
                shareButton.on("click", () => {
                    howspace.components.modal.show(shareableModalUrl, howspace.components.getCallback(shareableModalInit));
                });
            }

            // VJS 8 doesn't have 'firstplay' event anymore, this is what they suggest as a replacement.
            videoJsPlayer.ready(() => {
                videoJsPlayer.one('play', () => {
                // Handle showing the default subtitles. See notes on the variable.
                if (defaultSubtitle) {
                    const subtitles = videoJsPlayer.textTracks();
                    for (let i = 0; i < subtitles.length; i++) {
                            const subtitle = subtitles[i];
                            if (subtitle.language === defaultSubtitle.srclang && subtitle.label === defaultSubtitle.label) {
                                subtitle.mode = "showing";
                                break;
                            }
                        }
                    }
                });
            });

            videoJsPlayer.on('play', () => {
                // If the video is playing, then hide the play button.
                videoPlayer.find('.play-button-wrapper').addClass('d-none');
                videoPlayer.addClass('has-started');

                if (videoPlayer.data('start-at-seconds') && !isNaN(videoPlayer.data('start-at-seconds'))) {
                    videoJsPlayer.currentTime(videoPlayer.data('start-at-seconds'));
                    videoJsPlayer.play();
                    videoPlayer.dataAndAttr('start-at-seconds', null);
                }

                howspace.dispatchEvent(videoPlayer, howspace.components.videoPlayer.VIDEO_PLAY, eventDetail);
                pauseOtherPlayers(videoPlayer);
            });

            videoJsPlayer.on('playing', () => {
                videoPlayer.addClass('playing');
                howspace.activityTracker.setPlaybackActive(true);
            });

            videoJsPlayer.on('timeupdate', () => {
                videoPlayer.dataAndAttr('current-time', videoJsPlayer.currentTime());
            });

            videoJsPlayer.on('pause', () => {
                videoPlayer.removeClass('playing');
                howspace.dispatchEvent(videoPlayer, howspace.components.videoPlayer.VIDEO_PAUSE, eventDetail);
                howspace.activityTracker.setPlaybackActive(false);
            });

            if (videoPlayer.data('autoplay') && videoPlayer.data('autoplay') !== false) {
                // Wait 100 ms before calling play, otherwise starting playback randomly fails.
                setTimeout(() => {
                    const promise = videoJsPlayer.play();

                    if (promise !== undefined) {
                        // Sometimes it's possible that the promise will never end up to succeed or fail.
                        // Thus, we use 5 second timeout to fall back to fail use case.
                        let promiseTimeoutId = setTimeout(() => {
                            promiseTimeoutId = null;
                        }, 5000);

                        promise.then(() => {
                            if (promiseTimeoutId !== null) {
                                clearTimeout(promiseTimeoutId);
                                promiseTimeoutId = null;
                            }
                        }).catch(() => {
                            if (promiseTimeoutId !== null) {
                                clearTimeout(promiseTimeoutId);
                                promiseTimeoutId = null;
                            }
                        });
                    }
                }, 100);
            }

            videoJsPlayer.on('ended', () => {
                videoPlayer.removeClass('playing');
                howspace.dispatchEvent(videoPlayer, howspace.components.videoPlayer.VIDEO_ENDED, eventDetail);
            });

            if (typeof options.onTimeUpdate === 'function') {
                howspace.dispatchEvent(videoPlayer, howspace.components.videoPlayer.VIDEO_TIME_UPDATED, eventDetail);
            }

            videoJsPlayer.on('error', () => {
                destroyVideoJs(videoPlayer);
                videoPlayer.addClass('has-error');
            });
        });
    };

    const pauseOtherPlayers = currentPlayer => {
        $('.howspace-audio-player-initialized.playing, .howspace-video-player-initialized.playing').not(currentPlayer).each(async function () {
            await loadVideoJS();
            const otherVideoJsPlayer = videojs($(this).find('.video-js')[0]);
            if (!otherVideoJsPlayer.paused()) {
                otherVideoJsPlayer.pause();
            }
        });
    };

    /**
     * @param {*} videoPlayer
     */
    const destroyVideoJs = async (videoPlayer) => {
        if (!videoPlayer.is('.video-js-initialized')) {
            return;
        }
        videoPlayer.removeClass('video-js-initialized');
        videoPlayer.closest('.howspace-video-player, .howspace-video-player-wrapper').removeClass('playing');
        await loadVideoJS();
        videojs(videoPlayer.find('.video-js')[0]).dispose();
    };

    /**
     * @param {*} videoPlayer
     * @param {*} options
     * @returns
     */
    const initVideoPlayer = (videoPlayer, options = {}) => {
        if (videoPlayer.is('.howspace-video-player-initialized')) {
            return true;
        }
        videoPlayer.addClass('howspace-video-player-initialized');

        if (videoPlayer.data('background-url')) {
            videoPlayer.css('background-image', 'url(' + videoPlayer.data('background-url') + ')');
        }

        if (videoPlayer.data('video-width') && videoPlayer.data('video-height')) {
            videoPlayer.addClass('with-aspect-ratio');
            videoPlayer.css('aspect-ratio', videoPlayer.data('video-width') + '/' + videoPlayer.data('video-height'));
        }

        if (videoPlayer.data('autoplay') && videoPlayer.data('autoplay') !== false) {
            initVideoJs(videoPlayer, options);
        } else {
            videoPlayer.on('click', () => {
                videoPlayer.find('.play-button-wrapper').addClass('d-none');
                initVideoJs(videoPlayer, options);
            });
        }

        howspace.mediaShare.handleSharingMomentLink();
    };

    /**
     * @param {*} videoPlayer
     * @returns
     */
    const destroyVideoPlayer = (videoPlayer) => {
        if (!videoPlayer.is('.howspace-video-player-initialized')) {
            return true;
        }

        videoPlayer.removeClass('howspace-video-player-initialized');
        videoPlayer.removeClass('with-aspect-ratio');
        videoPlayer.removeAttr('style');
        videoPlayer.find('.play-button-wrapper').removeClass('d-none');

        videoPlayer.off('click');

        if (videoPlayer.is('.video-js-initialized')) {
            destroyVideoJs(videoPlayer);
        }
    };

    real.onTierReady(real.TIER_2, () => {
        real.events.on('uploadedfile:stored', (notification) => {
            // During duplication files are stored asynchronously. Listen for the uploaded file stored events
            // and enable any video players as soon as the mp4 baseline video file is stored.
            let videoPlayer = $('.howspace-video-player[data-is-stored="false"][data-uploadedfile-id="' + notification.object.uploadedfile.id + '"]');
            if (videoPlayer.length === 0) {
                videoPlayer = $('.howspace-video-player[data-background-is-stored="false"][data-uploadedfile-id="' + notification.object.uploadedfile.id + '"]');
            }

            // If the video player is not found, then return.
            if (videoPlayer.length === 0) {
                return;
            }

            videoPlayer.dataAndAttr('is-stored', true);
            videoPlayer.dataAndAttr('background-is-stored', true);

            // Remove the old stylys and recalculate the aspect ratio and set the background image.
            videoPlayer.removeAttr('style');
            videoPlayer.css('background-image', 'url(' + videoPlayer.data('poster-file-url') + ')');
            videoPlayer.css('aspect-ratio', videoPlayer.data('video-width') + '/' + videoPlayer.data('video-height'));
        });
    });

    return {
        VIDEO_PLAY: 'video-play',
        VIDEO_PAUSE: 'video-pause',
        VIDEO_TIME_UPDATED: 'video-time-updated',
        VIDEO_ENDED: 'video-ended',
        SUBTITLE_ADDED,
        init: (elem, options) => {
            elem.findIncludingSelf('.howspace-video-player:not(.howspace-video-player-initialized)').each(function () {
                initVideoPlayer($(this), options);
            });
        },
        destroy: (elem) => {
            elem.findIncludingSelf('.howspace-video-player.howspace-video-player-initialized').each(function () {
                destroyVideoPlayer($(this));
            });
        },
        destroyVideoJs: destroyVideoJs,
        pauseOtherPlayers: pauseOtherPlayers
    };

})();
